function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M501.333,501.333H10.667C4.776,501.333,0,496.558,0,490.667v-15.659c0.003-59.025,37.37-111.578,93.12-130.965 l54.869-19.093c4.021-1.402,8.491-0.279,11.371,2.859c24.326,28.159,59.438,44.7,96.64,45.525 c37.202-0.825,72.314-17.366,96.64-45.525c2.88-3.137,7.35-4.261,11.371-2.859l54.869,19.093l0,0 c55.75,19.387,93.117,71.941,93.12,130.965v15.659C512,496.558,507.224,501.333,501.333,501.333z M21.333,480h469.333v-4.992 c0.003-49.945-31.612-94.417-78.784-110.827l-48.384-16.832c-27.995,29.611-66.754,46.672-107.499,47.317 c-40.744-0.646-79.504-17.706-107.499-47.317l-48.384,16.832c-47.172,16.409-78.787,60.882-78.784,110.827V480z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M224,202.667h-21.333c-5.891,0-10.667-4.776-10.667-10.667s4.776-10.667,10.667-10.667H224 c5.891,0,10.667,4.776,10.667,10.667S229.891,202.667,224,202.667z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M309.333,202.667H288c-5.891,0-10.667-4.776-10.667-10.667s4.776-10.667,10.667-10.667h21.333 c5.891,0,10.667,4.776,10.667,10.667S315.224,202.667,309.333,202.667z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M256,352c-55.275,0-104.064-46.933-121.429-116.843c-1.42-5.72,2.066-11.508,7.787-12.928s11.508,2.066,12.928,7.787 C170.219,290.133,210.688,330.667,256,330.667s85.781-40.533,100.715-100.651c1.42-5.72,7.208-9.206,12.928-7.787 c5.72,1.42,9.206,7.208,7.787,12.928C360.064,305.067,311.275,352,256,352z"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M371.072,149.333c-5.891,0-10.667-4.776-10.667-10.667c1.428-57.656-44.154-105.552-101.81-106.98 s-105.552,44.154-106.98,101.81c-0.043,1.723-0.043,3.447,0,5.17c0,5.891-4.776,10.667-10.667,10.667s-10.667-4.776-10.667-10.667 c-0.905-69.438,54.652-126.461,124.09-127.366s126.461,54.652,127.366,124.09c0.014,1.092,0.014,2.184,0,3.276 C381.739,144.558,376.963,149.333,371.072,149.333z"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M297.92,288h-3.925c-14.681-0.002-27.477-9.993-31.04-24.235L259.627,256h-7.189l-3.883,9.301 c-3.89,13.596-16.409,22.898-30.549,22.699h-3.925c-10.699-0.001-20.69-5.348-26.624-14.251l-14.933-22.507 c-3.27-4.901-1.947-11.525,2.955-14.795c4.901-3.27,11.525-1.947,14.795,2.955l14.933,22.507c1.976,2.97,5.307,4.755,8.875,4.757 h3.925c4.896-0.001,9.162-3.335,10.347-8.085l7.125-17.365c1.662-3.972,5.55-6.556,9.856-6.549h21.333 c4.298,0.002,8.175,2.584,9.835,6.549l6.635,15.851c0.878,5.374,5.418,9.387,10.859,9.6h3.925c3.568-0.002,6.898-1.787,8.875-4.757 l14.933-22.507c3.27-4.901,9.893-6.224,14.795-2.955c4.901,3.27,6.224,9.893,2.955,14.795l-14.933,22.507 C318.61,282.652,308.619,287.999,297.92,288z"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M149.333,256c-5.891,0-10.667-4.776-10.667-10.667c0-5.891,4.776-10.667,10.667-10.667 c20.096,0.489,40.111-2.714,59.051-9.451c5.219-2.733,11.667-0.718,14.4,4.501c2.733,5.219,0.718,11.667-4.501,14.4 C196.31,252.594,172.876,256.632,149.333,256z"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M362.667,256c-23.542,0.632-46.977-3.407-68.949-11.883c-5.219-2.733-7.235-9.181-4.501-14.4 c2.733-5.219,9.181-7.235,14.4-4.501c18.939,6.737,38.955,9.94,59.051,9.451c5.891,0,10.667,4.776,10.667,10.667 C373.333,251.224,368.558,256,362.667,256z"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M234.667,170.667c-2.555-0.007-5.023-0.93-6.955-2.603c-16-13.781-42.667-28.779-49.493-21.867 c-4.237,4.092-10.99,3.975-15.083-0.262c-3.992-4.134-3.992-10.687,0-14.82c24.043-24.021,69.611,13.12,78.507,20.8 c4.465,3.842,4.97,10.577,1.128,15.043C240.74,169.317,237.78,170.672,234.667,170.667z"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M277.333,170.667c-5.891-0.003-10.664-4.782-10.661-10.673c0.002-3.093,1.346-6.033,3.685-8.058 c8.896-7.68,54.507-44.8,78.507-20.8c4.237,4.093,4.355,10.845,0.262,15.083c-4.093,4.237-10.845,4.355-15.083,0.262 c-0.089-0.086-0.176-0.173-0.262-0.262c-6.869-6.891-33.472,8.064-49.493,21.867C282.353,169.75,279.886,170.666,277.333,170.667z"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M367.083,243.2h-0.469c-5.885-0.254-10.45-5.23-10.197-11.115l5.952-139.925C327.982,81.058,292.13,75.162,256,74.667 c-36.096,0.517-71.913,6.428-106.261,17.536l5.952,139.925c0.247,5.891-4.328,10.867-10.219,11.115s-10.867-4.328-11.115-10.219 L128,85.781c-0.184-4.297,2.23-8.284,6.123-10.112C173.132,61.162,214.381,53.603,256,53.333 c41.647,0.259,82.927,7.819,121.963,22.336c3.859,1.854,6.237,5.835,6.037,10.112l-6.251,147.2 C377.509,238.697,372.803,243.205,367.083,243.2z"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M256,373.333c-5.214-0.002-9.662-3.774-10.517-8.917l-10.667-64c-1.141-5.779,2.619-11.39,8.398-12.531 c5.779-1.141,11.39,2.619,12.531,8.398c0.042,0.21,0.077,0.422,0.105,0.634l0.149,0.875l0.149-0.875 c1.141-5.779,6.752-9.539,12.531-8.398c5.535,1.093,9.261,6.306,8.504,11.897l-10.667,64 C265.662,369.56,261.214,373.331,256,373.333z"
});

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

var _ref16 = /*#__PURE__*/React.createElement("g", null);

var _ref17 = /*#__PURE__*/React.createElement("g", null);

var _ref18 = /*#__PURE__*/React.createElement("g", null);

var _ref19 = /*#__PURE__*/React.createElement("g", null);

var _ref20 = /*#__PURE__*/React.createElement("g", null);

var _ref21 = /*#__PURE__*/React.createElement("g", null);

var _ref22 = /*#__PURE__*/React.createElement("g", null);

var _ref23 = /*#__PURE__*/React.createElement("g", null);

var _ref24 = /*#__PURE__*/React.createElement("g", null);

var _ref25 = /*#__PURE__*/React.createElement("g", null);

var _ref26 = /*#__PURE__*/React.createElement("g", null);

var _ref27 = /*#__PURE__*/React.createElement("g", null);

var _ref28 = /*#__PURE__*/React.createElement("g", null);

var SvgAdmin = function SvgAdmin(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE082"
    },
    d: "M256,10.667c-69.326-0.131-125.632,55.962-125.763,125.287c-0.002,0.904,0.006,1.809,0.024,2.713 v0.448l3.989,93.867c0.031,0.719,0.131,1.433,0.299,2.133C151.936,305.067,200.725,352,256,352s104.064-46.933,121.429-116.843 c0.168-0.7,0.268-1.414,0.299-2.133l4.011-94.357c1.367-69.312-53.714-126.609-123.026-127.976 C257.809,10.673,256.904,10.665,256,10.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CFD8DC"
    },
    d: "M377.877,75.691C338.875,61.156,297.622,53.589,256,53.333 c-41.622,0.252-82.876,7.819-121.877,22.357c-3.885,1.825-6.298,5.802-6.123,10.091l6.187,147.2c0.04,1.047,0.234,2.082,0.576,3.072 l4.48,12.8c1.499,4.288,5.549,7.156,10.091,7.147c8.453-0.012,16.899-0.482,25.301-1.408l12.8,19.2 c5.989,8.913,16.014,14.269,26.752,14.293h3.84c14.159,0.229,26.694-9.11,30.528-22.741l3.883-9.344h7.211l3.285,7.659 c3.48,14.311,16.312,24.374,31.04,24.341h3.84c10.752-0.035,20.784-5.407,26.773-14.336l12.8-19.093 c8.395,0.932,16.834,1.41,25.28,1.429c4.534,0,8.573-2.866,10.069-7.147l4.48-12.8c0.342-0.99,0.536-2.025,0.576-3.072l6.187-147.2 C384.158,81.497,381.754,77.522,377.877,75.691z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#455A64"
    },
    d: "M418.88,344.021l-54.869-19.093c-4.021-1.402-8.491-0.279-11.371,2.859 c-24.322,28.167-59.435,44.716-96.64,45.547c-37.202-0.825-72.314-17.366-96.64-45.525c-2.88-3.137-7.35-4.261-11.371-2.859 L93.12,344.043C37.37,363.43,0.003,415.984,0,475.008v15.659c0,5.891,4.776,10.667,10.667,10.667h490.667 c5.891,0,10.667-4.776,10.667-10.667v-15.659C512.006,415.976,474.637,363.411,418.88,344.021z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#455A64"
    },
    d: "M224,202.667h-21.333c-5.891,0-10.667-4.776-10.667-10.667s4.776-10.667,10.667-10.667H224 c5.891,0,10.667,4.776,10.667,10.667S229.891,202.667,224,202.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#455A64"
    },
    d: "M309.333,202.667H288c-5.891,0-10.667-4.776-10.667-10.667s4.776-10.667,10.667-10.667h21.333 c5.891,0,10.667,4.776,10.667,10.667S315.224,202.667,309.333,202.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#455A64"
    },
    d: "M234.667,170.667c-2.555-0.007-5.023-0.93-6.955-2.603c-16-13.781-42.667-28.779-49.493-21.867 c-4.237,4.092-10.99,3.975-15.083-0.262c-3.992-4.134-3.992-10.687,0-14.82c24.043-24.021,69.611,13.12,78.507,20.8 c4.465,3.842,4.97,10.577,1.128,15.043C240.74,169.317,237.78,170.672,234.667,170.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#455A64"
    },
    d: "M277.333,170.667c-5.891-0.003-10.664-4.782-10.661-10.673c0.002-3.093,1.346-6.033,3.685-8.058 c8.896-7.68,54.507-44.8,78.507-20.8c4.237,4.093,4.355,10.845,0.262,15.083c-4.093,4.237-10.845,4.355-15.083,0.262 c-0.089-0.086-0.176-0.173-0.262-0.262c-6.869-6.891-33.472,8.064-49.493,21.867C282.353,169.75,279.886,170.666,277.333,170.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#455A64"
    },
    d: "M256,373.333c-5.214-0.002-9.662-3.774-10.517-8.917l-10.667-64 c-1.141-5.779,2.619-11.39,8.398-12.531c5.779-1.141,11.39,2.619,12.531,8.398c0.042,0.21,0.077,0.422,0.105,0.634l0.149,0.875 l0.149-0.875c1.141-5.779,6.752-9.539,12.531-8.398c5.535,1.093,9.261,6.306,8.504,11.897l-10.667,64 C265.662,369.56,261.214,373.331,256,373.333z"
  })), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAdmin, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/admin.2bd85279.svg";
export { ForwardRef as ReactComponent };